import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []


    if (data?.empresas === '' || data?.empresas === null)
        response.push(<Box>Selecione uma empresa.</Box>)

    if (data?.transportadora === '' || data?.transportadora === null)
        response.push(<Box>Selecione uma transportadora.</Box>)

    if (data?.nome_rota_regiao === '' || data?.nome_rota_regiao === null)
        response.push(<Box>Selecione uma rota/região.</Box>)

    if (data?.cobrado === '' || data?.cobrado === null)
        response.push(<Box>Digite a % cobrado.</Box>)

    if (data?.frete_minimo === '' || data?.frete_minimo === null)
        response.push(<Box>Digite o frete mínimo.</Box>)


    if (response.length === 0)
        return ''

    return (response)
}

export default validateData